/**
 * Route guard. If the user is not authenticated, redirect to /login while
 * remembering where they were trying to go. Optionally, a `roles` array can
 * be supplied and the user's role must be in it to enter the route; otherwise
 * they get sent to their role's safe landing page (sales for `user`, `/` for
 * everyone else).
 */
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'

const ROLE_HOME = {
  user: '/sales',
}

export function RequireAuth({ children, roles }) {
  const { isAuthenticated, user } = useAuth()
  const location = useLocation()
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }
  if (roles && user && !roles.includes(user.role)) {
    const fallback = ROLE_HOME[user.role] || '/'
    return <Navigate to={fallback} replace />
  }
  return children
}
